// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MobileCalculator-module--fadeInAnimation--85fb5";
export var send = "MobileCalculator-module--send--e7f9a";
export var sendButton = "MobileCalculator-module--sendButton--39334";
export var wrapper = "MobileCalculator-module--wrapper--3c472";